import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const AccountSuspended = () => {
  return (
    <>
      <div className={tw`flex h-[100vh] overflow-y-auto `}>
        <div className={tw`h-full w-full`}>
          <div
            className={tw`bg-primary-light w-full h-36 text-primary text-2xl flex items-center justify-center font-bold`}
          >
            Account Suspended !
          </div>
          <div
            className={tw`border-2 border-gray-400 w-2/3 mx-auto my-20 p-4 text-lg text-primary`}
            style={{ boxShadow: " 0px 3px 3px 2px gray" }}
          >
            <p>
              Your account has been suspended due to no-payment.Please settle
              your outstanding balance to restore access to our services.
            </p>
          </div>
          <div className={tw`mx-16 flex flex-col gap-y-2`}>
            <p>For any inquiries or assistance, please contact us at:</p>
            <p className={tw`text-primary`}>Phone no:+977-</p>
            <p className={tw`text-primary`}>Email:Support@careinfo.com</p>
          </div>
          <div
            className={tw`h-[30px] w-full text-gray-700 flex items-center text-white  bg-primary p-2 justify-center  mt-4`}
          >
            <h1>Copyright ©2024 Careinfo Solutions</h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountSuspended;
